import { NavigationTile } from '@srcDS/components/organisms/header/navigation/NavigationBanner/NavigationBanner.props';

export const getContentfulNavigationTiles = (contentfulNavigationTiles: NavigationTile[], categoryUrl: string) => {
  return contentfulNavigationTiles?.filter((tile: NavigationTile) => categoryUrl === tile.categoryIdentifier);
};

export const mapContentfulToNavigationTile = (contentfulTile) => {
  return {
    promoBackgroundImage: contentfulTile.promoBackgroundImage || null,
    promoBackgroundColor: contentfulTile.promoBackgroundColour || '',
    promoTitle: contentfulTile.promoTitle || '',
    promoText: contentfulTile.promoText || '',
    promoConditions: contentfulTile.promoConditions || '',
    promoLinks: contentfulTile.promoButton
      ? [
          {
            buttonTitle: contentfulTile.promoButton.title,
            buttonUrl: {
              type: 'link',
              openInNewWindow: false,
              link: contentfulTile.promoButton.url,
            },
            buttonIcon: null,
            iconPosition: 'left',
            buttonType: contentfulTile.promoButton.viewType || 'primary',
            buttonState: 'active',
          },
        ]
      : [],
  };
};
